import React, { createContext, useEffect, useState } from "react";
import { ChildrenDto } from "../types";

interface ISidebar {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const DEFAULT_VALUE = {
  isOpen: true,
  setOpen: () => {},
};

/** Onde fica lembrado se a barra estava recolhida. So conveniencia de quem usa. */
const CHAVE_RECOLHIDA = 'rico:sidebar-recolhida';

function lerRecolhida() {
  try {
    return window.localStorage.getItem(CHAVE_RECOLHIDA) === '1';
  } catch {
    return false;
  }
}

export const SidebarContext = createContext<ISidebar>(DEFAULT_VALUE);

/*
 * O item ativo nao mora mais aqui: a barra le a rota atual (NavLink). O indice
 * guardado antes se perdia nas paginas que nao tem item proprio - na tela do
 * relatorio nenhum item ficava marcado.
 */
export const SidebarProvider = ({ children }: ChildrenDto) => {
  const [isOpen, setOpen] = useState(() => !lerRecolhida());

  useEffect(() => {
    try {
      window.localStorage.setItem(CHAVE_RECOLHIDA, isOpen ? '0' : '1');
    } catch {
      // Navegador sem armazenamento: a barra so volta aberta no proximo acesso.
    }
  }, [isOpen]);

  return (
    <SidebarContext.Provider value={{ isOpen, setOpen }}>
      {children}
    </SidebarContext.Provider>
  );
};
